<template>
  <div v-html="rendered" />
</template>

<script setup>
import { computed } from "vue"
import { renderMarkdownPreview } from "@/lib/markdownPreview"

const props = defineProps({ source: { type: String, default: "" } })
const rendered = computed(() => renderMarkdownPreview(props.source))
</script>
